import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminAssetsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('asset');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
